import { render } from "./ViewProfile.vue?vue&type=template&id=78b5ef3c"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"

import "./ViewProfile.vue?vue&type=style&index=0&id=78b5ef3c&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__